import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './form-item-sharia-caf-loan.component.scss';
var FormItemShariaCafLoan = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemShariaCafLoan, _super);
    function FormItemShariaCafLoan(element) {
        return _super.call(this, element) || this;
    }
    FormItemShariaCafLoan.prototype.init = function () {
        this.form = this.element.querySelector("form");
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        this.buttonSubmit = this.element.querySelector(".js_submit-button");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector('.data-sharing-telesale-hide-btn');
        this.dataSharingTeleSaleShowBtn = this.element.querySelector('.data-sharing-telesale-show-btn');
        this.dataSharingTeleSaleTextArea = this.element.querySelector('.data-sharing-telesale');
        this.dataSharingSmsShowBtn = this.element.querySelector('.data-sharing-email-show-btn');
        this.dataSharingSmsHideBtn = this.element.querySelector('.data-sharing-email-hide-btn');
        this.dataSharingSmsTextArea = this.element.querySelector('.data-sharing-email');
        this.dataSharingEmailHideBtn = this.element.querySelector('.data-sharing-sms-hide-btn');
        this.dataSharingEmailShowBtn = this.element.querySelector('.data-sharing-sms-show-btn');
        this.dataSharingEmailTextArea = this.element.querySelector('.data-sharing-sms');
    };
    FormItemShariaCafLoan.prototype.bindEvents = function () {
        var _this = this;
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector(".js_business-reg");
        if (businessReg) {
            businessReg.addEventListener("input", function (event) {
                if ((event.inputType !== "deleteContentBackward") && (event.inputType !== "deleteContentForward")) {
                    var reg = event.target.value;
                    event.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener("blur", function (event) {
                var reg = event.target.value;
                event.target.value = _this.validationService.formatExpression(reg);
            });
        }
        //Submit Button Click
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _button = pEvent.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener('click', function (event) { return _this.closeForm("done"); });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeForm("close"); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute('hidden');
            _this.dataSharingTeleSaleShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleShowBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute('hidden');
            _this.dataSharingSmsShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsShowBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute('hidden');
            _this.dataSharingEmailShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailShowBtn.removeAttribute('hidden');
        });
    };
    FormItemShariaCafLoan.prototype.closeForm = function (type) {
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
            window.location.href = this.closeButton.getAttribute('data-url');
        }
        else {
            window.location.href = this.doneSubmit.getAttribute('data-url');
            // this.analyticsService.dtmFormComplete(`complete`, `true`);
            // this.analyticsService.completeDtmApplication();
        }
        this.form.reset();
    };
    FormItemShariaCafLoan.prototype.submitForm = function (form) {
        var _this = this;
        var _email = form.querySelector("input[name=email]");
        var _recipient = form.querySelector("input[name=recipient]");
        var _subject = form.querySelector("input[name=subject]");
        var _product = form.querySelector("input[name=product]");
        var _redirect = form.querySelector("input[name=redirect]");
        var _firstName = form.querySelector("input[name=first-name]");
        var _surname = form.querySelector("input[name=surname]");
        var _businessType = form.querySelector("select[name=business-type]");
        var _businessName = form.querySelector("input[name=bus-name]");
        var _businessRegistrationNumber = form.querySelector("input[name=bus-regno]");
        var _idnumber = form.querySelector("input[name=idnumber]");
        var _emailAddress = form.querySelector("input[name=email-address]");
        var _phoneNumber = form.querySelector("input[name=phone-number]");
        var _province = form.querySelector("select[name=province]");
        var _loanAmount = form.querySelector("input[name=loan-amount]");
        var _purposeOfLoan = form.querySelector("input[name=loan-purpose]");
        var _standardBankCustomer = form.querySelector("input[name=existing-customer]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        var _postData = {
            'email': (_email ? _email.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'product': (_product ? _product.value : ""),
            'firstName': (_firstName ? _firstName.value : ''),
            'emailAddress': (_emailAddress ? _emailAddress.value : ''),
            'surname': (_surname ? _surname.value : ''),
            'business': (_businessType ? _businessType.value : ''),
            "nameOfYourBusiness": (_businessName ? _businessName.value : ''),
            "businessRegistrationNumber": (_businessRegistrationNumber ? _businessRegistrationNumber.value : ''),
            "contactNumber": (_phoneNumber ? _phoneNumber.value : ''),
            "idNumber": (_idnumber ? _idnumber.value : ''),
            "province": (_province ? _province.value : ''),
            "howMuchDoYouNeedFinance": (_loanAmount ? _loanAmount.value : ''),
            "whatDoYouWantToFinance": (_purposeOfLoan ? _purposeOfLoan.value : ''),
            'standardBankCustomer': ((_standardBankCustomer ? (_standardBankCustomer.checked ? "YES" : "NO") : "NO")),
            'dataPrivacyConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            "dataSharingTelesale": this.getDataConsentValue(form, 'data-sharing-telesale'),
            "dataSharingEmail": this.getDataConsentValue(form, 'data-sharing-email'),
            "dataSharingSms": this.getDataConsentValue(form, 'data-sharing-sms'),
            'dataSharingWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharingWithThirdPartiesMarketingConsent': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingAcrossBordersWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-boarders'),
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/shariah-commercial-asset-finance";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (pResponse) {
            if (pResponse.data === "invalid") {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", pResponse.code);
                _this.dtmVirtualPage('thank you');
                _this.showDisplayView("success");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemShariaCafLoan.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemShariaCafLoan.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    FormItemShariaCafLoan.prototype.dtmVirtualPage = function (pPageNameNew) {
        var taggingValue = pPageNameNew === 'thank you' ?
            'business:products and services:borrow for your needs:vehicle and asset finance:Shariah commercial asset finance success thank you' : "business:products and services:borrow for your needs:business loans:vehicle and-asset finance: Shariah commercial asset finance";
        dataLayer.pageName = taggingValue;
        if (typeof _satellite === 'object') {
            _satellite.track('globalVirtualPageView');
        }
    };
    return FormItemShariaCafLoan;
}(Base));
export { FormItemShariaCafLoan };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-sharia-caf-loan/form-item-sharia-caf-loan.component.ts
// module id = 1019
// module chunks = 0